// Etiqueta y color por rol de usuario. Fuente única para la grilla de Usuarios
// y para el badge de rol del Header, así ambos quedan siempre consistentes.
export const ROLE_CONFIG = {
  superuser: { label: 'Socio', bg: '#f3e8ff', color: '#7e22ce' },
  administrator: { label: 'Administrador', bg: '#e8f0fb', color: '#4a7bc4' },
  employee: { label: 'Empleado', bg: '#f0f4f7', color: '#596064' },
};
